<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
import Vue from 'vue'
export default {
  extends: baseList,
  components: {
  },
  data() {
    return {
      table: {
        mname: 'devicedelivery',
        key: 'id',
        url: {
          del: '/admin/system/delivery'
        },
        output: false,
      },
      actions: [
        { label: "入库记录", type: "info", onClick: this.toretrieval, auth: "" },
        { label: "领用记录", type: "info", onClick: this.tocheckout, auth: "" },
        { label: "盘点记录", type: "info", onClick: this.totakeStock, auth: "" },
        { label: "维修记录", type: "info", onClick: this.tomainten, auth: "" },
        { label: "损坏记录", type: "info", onClick: this.todamage, auth: "" },
        { label: "报废记录", type: "info", onClick: this.toscrap, auth: "" },
        { label: "关联记录", type: "info", onClick: this.toassociation, auth: "" },
      ],
      filters: [
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '资产名称',
          key: 'facilityName',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            const row = params.row
            const text = row.facilityName
            return <span style={{ 'font-size': '14px' }} >{text}</span>
          },
        },
        {
          title: '核算科室',
          key: 'checkDeskName',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '出库科室',
          key: 'deskName',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '物理地址',
          key: 'installationSite',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '出库人',
          key: 'deliveryBy',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '备注',
          minWidth: 180,
          align: 'left',
          key: 'remark',
        },
        {
          title: '出库时间',
          minWidth: 180,
          align: 'center',
          key: 'createTime',
        },
      ],
    }
  },
  created() {
    let query = this.$route.query
    if (query.facilityId) {
      this.query.facilityId = query.facilityId

    }
    this.facilityId = query.facilityId
    this.facilityNo = query.facilityNo
  },
  methods: {
    //入库记录
    toretrieval(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.replace({
        name: "deviceRecordretrieval_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //设备档案
    toreedit(row = {}) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: this.facilityId },
      });
    },
    //损坏记录
    todamage(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.replace({
        name: "deviceRecorddamage_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //出库记录
    tocheckout(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.replace({
        name: "deviceRecordcheckout_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    totakeStock() {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.replace({
        name: "deviceTakeStockList_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //报废记录
    toscrap(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.replace({
        name: "deviceRecordscrap_list",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
    //维修记录
    tomainten(row = {}) {
      let facilityId = this.facilityId
      let facilityNo = this.facilityNo
      $utils.url.replace({ name: 'deviceMaintenance_list', query: { facilityId: facilityId, facilityNo: facilityNo } })
    },
    //关联记录
    toassociation(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo;
      $utils.url.push({
        name: "deviceAssociation_list_cus",
        query: { facilityId: facilityId, facilityNo: facilityNo },
      });
    },
  },
}
</script>
<style scoped></style>
